import { ProductCartContextProvider } from "./context/CartProductContext";
import { Helmet, HelmetProvider } from "react-helmet-async";
import MyRoutes from "routers/index";
import { useEffect, useState } from "react";
import { OnlineOrderSettingsProvider } from "./context/OnlineOrderSettingsContext";
import Cookies from "js-cookie";
import { MenuScheduleProvider } from "./context/MenuScheduleContext";

function App() {
  const title = Cookies.get("onlineOrderSettingsTitleText") ?? null;
  const [titletext] = useState(title);

  // Apply theme on initial load
  useEffect(() => {
    const theme = Cookies.get("theme") || "system";
    if (!Cookies.get("theme")) {
      Cookies.set("theme", "system");
    }
    const root = document.documentElement;
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const applyTheme = () => {
      const isDark =
        theme === "dark" || (theme === "system" && mediaQuery.matches);
      if (isDark) {
        root.classList.add("dark");
        root.classList.remove("light");
        document.body.classList.add("dark");
        document.body.classList.remove("light");
      } else {
        root.classList.remove("dark");
        root.classList.add("light");
        document.body.classList.remove("dark");
        document.body.classList.add("light");
      }
    };

    applyTheme();

    if (theme === "system") {
      mediaQuery.addEventListener("change", applyTheme);
      return () => mediaQuery.removeEventListener("change", applyTheme);
    }
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="theme-color" content="#FFFFFF" />
        <meta name="description" content="Basil POS Online Ordering" />
        <title>{titletext}</title>
      </Helmet>
      <OnlineOrderSettingsProvider>
      <MenuScheduleProvider>
        <ProductCartContextProvider>
          <div className="bg-white text-base dark:bg-slate-900 text-slate-900 dark:text-slate-200">
            <MyRoutes />
          </div>
        </ProductCartContextProvider>
        </MenuScheduleProvider>
      </OnlineOrderSettingsProvider>
    </HelmetProvider>
  );
}

export default App;
